import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { 
  FaRocket, 
  FaHeart, 
  FaHandsHelping, 
  FaChartLine, 
  FaGraduationCap,
  FaCalculator,
  FaLightbulb,
  FaUsers,
  FaArrowRight,
  FaChevronLeft, 
  FaChevronRight,
  FaExternalLinkAlt,
  FaFlask, 
  FaUniversalAccess, 
  FaVenusMars,
  FaTheaterMasks,
  FaLeaf,
  FaHandHoldingHeart,
  FaBalanceScale,
  FaMicroscope,
  FaTransgender,
  FaRainbow,
  FaPrism,
  FaFlag,
  FaBrain,
  FaInfoCircle,
  FaCheck,
  FaTimes
} from 'react-icons/fa';
import HeroSection from '../components/HeroSection';
import WhyChooseUs from '../components/WhyChooseUs';
import FiscalSponsorship from '../components/FiscalSponsorship';
import NewCTASection from '../components/NewCTASection';
import Leadership from '../components/Leadership';
import '../styles/Home.css';
import { causes } from '../data/causes';

const Home = () => {
  const [showIRSRules, setShowIRSRules] = useState(false);
  const [activeSlide, setActiveSlide] = useState(0);

  

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setShowIRSRules(false);
      }
    };
    
    const handleClickOutside = (event) => {
      if (showIRSRules) {
        setShowIRSRules(false);
      }
    };
   
    const handleScroll = () => {
      if (showIRSRules) {
        setShowIRSRules(false);
      }
    };

    if (showIRSRules) {
      window.addEventListener('keydown', handleEscape);
      document.addEventListener('click', handleClickOutside);
      window.addEventListener('scroll', handleScroll);
    }

    return () => {
      window.removeEventListener('keydown', handleEscape);
      document.removeEventListener('click', handleClickOutside);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [showIRSRules]);

  const openCalendly = () => {
    if (!window.Calendly) {
      const script = document.createElement('script');
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      document.body.appendChild(script);

      script.onload = () => {
        initCalendly();
      };
    } else {
      initCalendly();
    }
  };

  const initCalendly = () => {
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: 'https://calendly.com/leighton-jacobus',
        prefill: {},
        text: 'Schedule a Call',
        color: '#8B5CF6',
        branding: true,
        hideEventTypeDetails: false,
        hideGdprBanner: true,
        backgroundColor: '#111827',
        textColor: '#ffffff',
        primaryColor: '#8B5CF6'
      });
    }
  };

  const handleCarouselSlide = (direction) => {
    if (direction === 'next') {
      setActiveSlide((prev) => (prev === 2 ? 0 : prev + 1));
    } else {
      setActiveSlide((prev) => (prev === 0 ? 2 : prev - 1));
    }
  };

  return (
    <div className="home-container">
      <HeroSection />
      <FiscalSponsorship />
      <WhyChooseUs />
      
      <section className="values-causes-section">
        <div className="section-content">
          <div className="values-section">
            <div className="values-header">
              <h2>Our Values & Support</h2>
              <p className="section-subtitle">
                We're proud to champion initiatives that advance human knowledge and create a more equitable, inclusive world
              </p>
              
              <div className="values-icons">
  <FaRainbow className="value-icon rainbow" />
  <FaMicroscope className="value-icon science" />
  <div className="value-icon gender-container">
    <FaTransgender className="gender-icon" />
  </div>
  <FaLeaf className="value-icon nature" />
  <FaHeart className="value-icon heartbeat" />
</div>
            </div>

            <Link to="/our-story" className="learn-more-values">
              <span>Learn More About Our Mission</span>
              <FaArrowRight className="arrow-icon" />
            </Link>
          </div>

          <div className="causes-overview">
            <h2>The Causes We Champion</h2>
            <div className="causes-header">
              <p className="section-subtitle">
                From grassroots initiatives to global movements, we support changemakers across all sectors.
              </p>
              <button 
                className="irs-rules-button"
                onClick={() => setShowIRSRules(true)}
              >
                <FaInfoCircle />
                View 501(c)(3) Guidelines
              </button>
            </div>

            {showIRSRules && (
              <div className="irs-modal-overlay" onClick={() => setShowIRSRules(false)}>
                <div className="irs-modal" onClick={e => e.stopPropagation()}>
                  <button 
                    className="modal-close"
                    onClick={() => setShowIRSRules(false)}
                  >
                    ×
                  </button>
                  
                  <h2>501(c)(3) Qualification Guidelines</h2>
                  
                  <div className="rules-grid">
                    <div className="rules-section allowed">
                      <h3><FaCheck /> Allowable Activities</h3>
                      <ul>
                        <li>Relief of poverty and distress</li>
                        <li>Educational advancement</li>
                        <li>Scientific research</li>
                        <li>Public health initiatives</li>
                        <li>Community improvement</li>
                        <li>Arts and cultural programs</li>
                        <li>Religious activities</li>
                        <li>Environmental conservation</li>
                      </ul>
                    </div>

                    <div className="rules-section prohibited">
                      <h3><FaTimes /> Prohibited Activities</h3>
                      <ul>
                        <li>Political campaign involvement</li>
                        <li>Substantial lobbying</li>
                        <li>Private benefit distribution</li>
                        <li>Illegal activities</li>
                        <li>For-profit operations</li>
                        <li>Insider transactions</li>
                        <li>Partisan activities</li>
                        <li>Unrelated business income</li>
                      </ul>
                    </div>
                  </div>

                  <div className="rules-footer">
                    <a 
                      href="https://www.irs.gov/charities-non-profits/charitable-organizations/exemption-requirements-501c3-organizations"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="irs-link"
                    >
                      <FaExternalLinkAlt /> View Full IRS Guidelines
                    </a>
                  </div>
                </div>
              </div>
            )}

            <div className="causes-categories-grid">
              <div className="category-card">
                <div className="category-icon-wrapper">
                  <FaBalanceScale className="category-icon" />
                </div>
                <h3>Social Justice</h3>
                <ul>
                  <li>Civil Rights & Advocacy</li>
                  <li>Immigration Reform</li>
                  <li>Economic Equality</li>
                  <li>Criminal Justice Reform</li>
                </ul>
              </div>
              <div className="category-card">
                <div className="category-icon-wrapper">
                  <FaGraduationCap className="category-icon" />
                </div>
                <h3>Education</h3>
                <ul>
                  <li>STEM Programs</li>
                  <li>Arts Education</li>
                  <li>Adult Learning</li>
                  <li>Educational Equity</li>
                </ul>
              </div>
              <div className="category-card">
                <div className="category-icon-wrapper">
                  <FaBrain className="category-icon" />
                </div>
                <h3>Health & Research</h3>
                <ul>
                  <li>Mental Health</li>
                  <li>Medical Research</li>
                  <li>Public Health</li>
                  <li>Healthcare Access</li>
                </ul>
              </div>
              <div className="category-card">
                <div className="category-icon-wrapper">
                  <FaLeaf className="category-icon" />
                </div>
                <h3>Environment</h3>
                <ul>
                  <li>Climate Action</li>
                  <li>Conservation</li>
                  <li>Sustainable Energy</li>
                  <li>Environmental Justice</li>
                </ul>
              </div>
              <div className="category-card">
                <div className="category-icon-wrapper">
                  <FaTheaterMasks className="category-icon" />
                </div>
                <h3>Arts & Culture</h3>
                <ul>
                  <li>Documentary Film</li>
                  <li>Performing Arts</li>
                  <li>Cultural Preservation</li>
                  <li>Community Arts</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="start-journey-section">
        <div className="section-content">
          <h2 className="section-title">Start Your Journey</h2>
          <p className="section-subtitle">
            Whether you're just beginning or looking to scale your impact, we're here to support your vision
          </p>
          <div className="journey-grid">
            <div className="journey-card">
              <div className="icon-wrapper">
                <FaGraduationCap className="journey-icon" />
              </div>
              <h3>Impact Academy</h3>
              <p>
                Your trusted resource for fiscal sponsorship excellence. Whether you're launching 
                a mission, exploring giving, or growing your fiscal sponsor organization—join our 
                community advancing the future of philanthropy.
              </p>
              <Link to="/academy" className="journey-button academy">Explore Academy</Link>
            </div>
            <div className="journey-card">
              <div className="icon-wrapper">
                <FaCalculator className="journey-icon" />
              </div>
              <h3>Calculate Your Savings</h3>
              <p>
              Reimagine your nonprofit strategy with our advanced 501(c)(3) cost comparison tool. See how fiscal sponsorship stacks up against independent operation with precision-tailored insights.               </p>
              <Link to="/cost-calculator" className="journey-button secondary">Try Calculator</Link>
            </div>
            <div className="journey-card">
              <div className="icon-wrapper">
                <FaRocket className="journey-icon" />
              </div>
              <h3>Launch Your Vision</h3>
              <p>
                Ready to create lasting impact? Apply today—it's free and fast. Focus on your 
                mission while we handle the rest.
              </p>
              <Link to="/apply" className="journey-button primary">Apply Now</Link>
            </div>
          </div>
        </div>
      </section>

      <section className="featured-causes-section">
        <div className="section-content">
          <h2>Featured Causes</h2>
          <p className="section-subtitle">
            Discover and support vetted charitable projects aligned with your values
          </p>
          
          <div className="causes-preview-grid">
            {causes.map((cause) => (
              <div key={cause.id} className="cause-preview-card">
                <div className="cause-icon-wrapper">
                  {cause.icon}
                </div>
                <div className="cause-content">
                  <h3>{cause.name}</h3>
                  <p>{cause.shortDescription}</p>
                  <div className="cause-impact">
                    <FaHeart />
                    <span>${cause.fundsRaised.toLocaleString()} raised</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="causes-footer">
            <Link to="/causes" className="explore-more-link">
              <div className="explore-more-link-content">
                <FaUsers className="explore-icon" />
                <div className="explore-text">
                  <h4>Explore All Causes</h4>
                  <p>Discover more impactful initiatives</p>
                </div>
                <FaArrowRight className="arrow-icon" />
              </div>
            </Link>
            <Link to="/academy" className="academy-link">
              <div className="academy-link-content">
                <FaGraduationCap className="academy-icon" />
                <div className="academy-text">
                  <h4>Impact Academy</h4>
                  <p>Discover innovative giving solutions</p>
                </div>
                <FaArrowRight className="arrow-icon" />
              </div>
            </Link>
          </div>
        </div>
      </section>

      <Leadership />

      <section className="final-cta-section">
        <div className="section-content">
          <h2>Ready to Make an Impact?</h2>
          <p className="cta-subtitle">
            Join our growing community of changemakers and start your journey today. 
            There's so much more to explore as we continue to expand our platform.
          </p>
          
          <div className="cta-options">
            <div className="cta-card">
              <h3>Start Your Journey</h3>
              <p>Ready to launch your mission? Apply now and join our community of innovators.</p>
              <Link to="/apply" className="cta-button primary">
                Apply Now
                <FaArrowRight className="button-icon" />
              </Link>
            </div>

            <div className="cta-card">
              <h3>Let's Talk</h3>
              <p>Have questions? Schedule a call with our team to learn more about how we can help.</p>
              <button onClick={openCalendly} className="cta-button secondary">
                Schedule a Call
                <FaArrowRight className="button-icon" />
              </button>
            </div>
          </div>

          <div className="explore-more-footer">
            <p>Keep Exploring</p>
            <div className="explore-links">
              <Link to="/academy">Impact Academy</Link>
              <span className="separator">•</span>
              <Link to="/causes">Browse Causes</Link>
              <span className="separator">•</span>
              <Link to="/our-story">Our Story</Link>
              <span className="separator">•</span>
              <Link to="/cost-calculator">Cost Calculator</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
